// Predicate-generating function. Often useful outside of Underscore.
export default function noop(){}



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/noop.js
// module id = 127
// module chunks = 0 1